const buttonFormActions = {
  cancel: 'Cancelar ação',
  reopen: 'Reabrir ação',
  done: 'Concluir ação'
};

export default buttonFormActions;
